import StatCard from './StatCard';
import './StatCard.css';

export default StatCard;



// WEBPACK FOOTER //
// ./src/shared/components/StatCard/index.js